/**
 * Notify service.
 *
 * Usage:
 * The Notify service can be used to either display corner (bottom right) notifications or central notifications.
 *
 * @param message: Message string.
 * @param options: Optional parameters specified as an object:
 *                 - timeout: Timeout in milliseconds, defaults to 6000.
 *                 - when: 'immediately' or 'onReload'. If undefined, defaults to 'immediately'.
 *                 - location: 'corner' or 'central'. If underfined, defaults to 'corner'.
 *                 - contentClass: Additional class to add to the notification-box-content class.
 *
 * Basic Examples:
 * Notify.info('Info message');
 * Notify.success('Success message');
 * Notify.error('Error message');
 * Notify.unhandledError();
 *
 * More advanced examples:
 * Notify.error('Central error message', {location: 'central'});
 * Notify.info('Using all the options', {timeout: 3000, when: 'onReload', location: 'corner'});
 */

/**
 * UseNotify service is a connector between angular Notify service and react useNotify hook.
 * Check NgApp.tsx file to see how it's done.
 *
 * Notify service can't be fully replaced with react implementation for now
 * because of onReload and hjCentralNotification functionalities.
 * As soon as react Toast component will support displaying messages after page reload
 * and showing them in the center of the screen Notify service can be removed and replaced with UseNotify.
 */
angular.module('hjApp.ui').service('Notify', [
    '$rootScope',
    'SessionStorage',
    'UseNotify',
    function ($rootScope, SessionStorage, UseNotify) {
        function showNotification(message, cls, options) {
            var when = options['when'] || 'immediately',
                location = options['location'] || 'corner',
                timeout = options['timeout'] || 6000,
                notification = {
                    message: message,
                    cls: cls,
                    timeout: timeout
                },
                eventType = {
                    central: 'hjCentralNotification',
                    corner: 'hjNotification'
                }[location];

            if (typeof eventType === 'undefined') {
                throw new Error('Bad value "' + location + '" for parameter "location"');
            }

            if (when === 'immediately') {
                $rootScope.$emit(eventType, notification);
            } else if (when === 'onReload') {
                SessionStorage.set(eventType, notification);
            } else {
                throw new Error('Bad value "' + when + '" for parameter "when"');
            }
        }

        this.info = function (message, options) {
            if (options || !UseNotify) {
                showNotification(message, 'notification-box-info', options || {});
            } else {
                UseNotify.info(message);
            }
        };

        this.success = function (message, options) {
            if (options || !UseNotify) {
                showNotification(message, `notification-box-success ${options?.contentClass ?? ''}`, options || {});
            } else {
                UseNotify.success(message);
            }
        };

        this.error = function (message, options) {
            if (options || !UseNotify) {
                showNotification(message, 'notification-box-error', options || {});
            } else {
                UseNotify.error(message);
            }
        };

        this.unhandledError = function (options) {
            if (options || !UseNotify) {
                showNotification('Sorry, we could not complete that request.', 'notification-box-error', options || {});
            } else {
                UseNotify.unhandledError();
            }
        };
    }
]);
